var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 34,
    viewBox: "0 0 46 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 180415"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mail Box"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.3843 12.2332C33.2845 12.2332 31.2318 12.8558 29.4859 14.0224C27.74 15.189 26.3793 16.8471 25.5757 18.787C24.7722 20.7269 24.5619 22.8616 24.9716 24.921C25.3812 26.9805 26.3924 28.8722 27.8771 30.3569C29.3619 31.8417 31.2536 32.8528 33.313 33.2625C35.3725 33.6721 37.5071 33.4619 39.4471 32.6583C41.387 31.8548 43.0451 30.494 44.2117 28.7481C45.3783 27.0022 46.0009 24.9496 46.0009 22.8498C45.9966 20.0354 44.8767 17.3376 42.8866 15.3475C40.8965 13.3574 38.1986 12.2375 35.3843 12.2332ZM39.1246 24.1075C38.8497 24.3691 38.4924 24.5269 38.1138 24.5538C37.7353 24.5806 37.3592 24.4748 37.0503 24.2545V25.2998C37.0503 25.733 36.8782 26.1485 36.5719 26.4548C36.2655 26.7611 35.8501 26.9332 35.4169 26.9332C34.9837 26.9332 34.5683 26.7611 34.262 26.4548C33.9557 26.1485 33.7836 25.733 33.7836 25.2998V24.2218C33.4451 24.3977 33.0557 24.4495 32.683 24.3684C32.3103 24.2872 31.9778 24.0782 31.7431 23.7775C31.5083 23.4768 31.3862 23.1035 31.398 22.7222C31.4097 22.341 31.5545 21.9758 31.8073 21.6902L34.2573 19.2402C34.4091 19.0871 34.5897 18.9656 34.7888 18.8826C34.9878 18.7997 35.2013 18.757 35.4169 18.757C35.6325 18.757 35.846 18.7997 36.0451 18.8826C36.2441 18.9656 36.4247 19.0871 36.5766 19.2402L39.1246 21.7882C39.2777 21.94 39.3992 22.1206 39.4821 22.3197C39.565 22.5187 39.6077 22.7322 39.6077 22.9478C39.6077 23.1634 39.565 23.3769 39.4821 23.576C39.3992 23.775 39.2777 23.9556 39.1246 24.1075Z",
    fill: "#044B7F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.5009 22.8498C21.4864 26.1375 22.6447 29.3227 24.7676 31.8332H5.16759C3.86803 31.8332 2.62169 31.3169 1.70276 30.398C0.783836 29.4791 0.267588 28.2327 0.267588 26.9332V5.69983C0.26581 4.7951 0.514554 3.90754 0.986254 3.1355L17.8913 15.4998C18.7115 16.0689 19.686 16.3738 20.6843 16.3738C21.6825 16.3738 22.657 16.0689 23.4773 15.4998L23.6406 15.3855C22.2277 17.6176 21.4851 20.2082 21.5009 22.8498Z",
    fill: "#044B7F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.7536 12.8702L3.68164 1.04485C4.15984 0.880397 4.66229 0.797574 5.16797 0.79985H36.2013C36.8579 0.803727 37.5072 0.93693 38.1123 1.19185L21.6156 12.8702C21.3422 13.0599 21.0174 13.1615 20.6846 13.1615C20.3519 13.1615 20.0271 13.0599 19.7536 12.8702Z",
    fill: "#044B7F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M41.0998 5.70009V10.2081C39.3038 9.39394 37.3551 8.97082 35.3832 8.96676C34.3499 8.96327 33.3196 9.07835 32.3125 9.30976L40.4792 3.47876C40.8599 4.15927 41.0726 4.92081 41.0998 5.70009Z",
    fill: "#044B7F"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 8191",
    x: 5,
    y: 17,
    width: 12,
    height: 1,
    rx: 0.5,
    fill: "#FAF6E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 8192",
    x: 5,
    y: 21,
    width: 12,
    height: 1,
    rx: 0.5,
    fill: "#FAF6E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 8193",
    x: 5,
    y: 25,
    width: 12,
    height: 1,
    rx: 0.5,
    fill: "#FAF6E5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.b2771d0ea8f2a59af7473a791eb89b14.svg";
export { ForwardRef as ReactComponent };